// eslint-disable-next-line simple-import-sort/imports
import "./instrument";

import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import "./index.css";
import Highcharts from "highcharts";
import AuthorisedUser from "@/components/AuthorisedUser";
import { store } from "@/store";
import AuthProvider from "./providers/AuthProvider";
import NimbusGlobalProvider from "./providers/NimbusGlobalProvider";

Highcharts.setOptions({
  time: {
    timezone: "Europe/London",
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <AuthProvider>
        <AuthorisedUser
          component={<NimbusGlobalProvider />}
          dataTestId="nimbus-app-ui"
        />
      </AuthProvider>
    </ReduxProvider>
  </StrictMode>
);
